module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bg-9618f3e4386b8a9f664a4b7ff71178bc.svg";